//http://52.209.17.119:8080/api/hosts?token=15Cp@uZIx66jUPF0dQMa3?BM.sCv)E&list=1

import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { HostData } from "../classes/host-data.class"

@Injectable()
export class HttpService {

    private mailServerUrl = "https://bgilzu5l16.execute-api.eu-west-1.amazonaws.com/production";
    private mailheaders = new Headers({
        'Content-Type': 'application/json'
    });

    constructor(private http: Http){}

    /* --------------------------- */
    /*          Mail              */
    /* --------------------------- */
    //Create
    public listHosts() {
        let token = '15Cp@uZIx66jUPF0dQMa3?BM.sCv)E';
        let list = '1';
        let path = this.mailServerUrl + '/hosts?' + 'token=' + token + '&' + 'list=' + list;
        return this.http.get(path, { headers: this.mailheaders }).map((response: Response) => response.json());
    }

    public addHost(hostData:HostData) {
        let token = '15Cp@uZIx66jUPF0dQMa3?BM.sCv)E';
        let secretkey = hostData.secretkey;
        let domain = hostData.domain;
        let sendtoaddr = hostData.sendtoaddr;
        let sendfromaddr = hostData.sendfromaddr;
        let path = this.mailServerUrl + '/hosts?' + 'token=' + token + '&' + 'secretkey=' + secretkey + '&' + 'domain=' + domain + '&' + 'sendtoaddr=' + sendtoaddr + '&' + 'sendfromaddr=' + sendfromaddr;
        return this.http.get(path, { headers: this.mailheaders }).map((response: Response) => response.text());
    }

    

    //Read

    //Update

    //Delete

    /* --------------------------- */
}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/services/http.service.ts